module.exports = __webpack_public_path__ + "img/golf-shop.9a683382.png";